export default __webpack_public_path__ + "static/media/mariana.809880ff.jpg";